export default __webpack_public_path__ + "static/media/Malevolent Gauntlets.f5b5bcba.jpg";